import { SignIn } from "@clerk/clerk-react";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { AuthSceneLayout } from "@/components/auth/AuthSceneLayout";
import { clerkAuthAppearance } from "@/components/auth/clerkAppearance";

export const Route = createFileRoute("/_public/sign-in/$")({
	validateSearch: (
		search: Record<string, unknown>,
	): { redirectTo?: string } => ({
		redirectTo:
			typeof search.redirectTo === "string" && search.redirectTo.length > 0
				? search.redirectTo
				: undefined,
	}),
	component: SignInPage,
});

function SignInPage() {
	const { t } = useTranslation();
	const { redirectTo } = Route.useSearch();
	const forceRedirectUrl = redirectTo;
	const signUpUrl = redirectTo
		? `/sign-up?redirectTo=${encodeURIComponent(redirectTo)}`
		: "/sign-up";

	return (
		<AuthSceneLayout
			footer={
				<p className="text-sm text-base-content/70">
					{t("common.dontHaveAccount")}{" "}
					<Link to={signUpUrl} className="link link-primary font-medium">
						{t("common.signUp")}
					</Link>
				</p>
			}
		>
			<SignIn
				routing="path"
				path="/sign-in"
				appearance={clerkAuthAppearance}
				// Keep the default app landing as fallback, but prefer redirectTo when present
				fallbackRedirectUrl="/app/select-organization"
				forceRedirectUrl={forceRedirectUrl}
				// Ensure switching to sign-up inside Clerk UI also preserves redirectTo
				signUpUrl={signUpUrl}
			/>
		</AuthSceneLayout>
	);
}
